import { LOCALES } from '@marketplace/i18n';
import {
  appStatusI18n,
  documentationI18n,
  descriptionI18n,
  technicalDetailsI18n,
  activateDeactivateCompletionI18n,
  confirmModalI18n,
  transactionLogI18n,
} from './components';

export const appPageI18n = {
  [LOCALES.ENG]: {
    app_page_apps_link: 'Apps',
    app_page_app_details_title: 'App Details',
    app_page_app_activate_title: 'Activate',
    app_page_app_activate_header_title: 'Activate App',
    app_page_app_deactivate_title: 'Deactivate',
    app_page_app_deactivate_header_title: 'Deactivate App',
    app_page_app_register_title: 'Register',
    app_page_app_register_header_title: 'Register App',
    app_page_app_publish_header_title: 'Publish App',
    app_page_app_submit_to_publish_header_title: 'Submit for Review Application',
    app_page_app_submit_to_publish_success: 'Application Submission Successful!',

    app_page_confirm_publish_modal_text:
      'Please confirm that this application is ready to be published in the App Gallery.',
    app_page_confirm_readytopublish_modal_text:
     'Please confirm that this application is ready to be submitted to Greenway Admin for reviewing.',
    app_page_app_publish_title: 'Publish',
    app_page_app_submit_to_publish_title: 'Submit for Review',

    app_page_app_activated_title: 'Activated!',
    app_page_app_deactivated_title: 'Deactivated!',
    app_page_app_cancel_title: 'Cancel',
    app_page_confirm_activate_text:
      'Please confirm if you want to activate {appName} application.',
      app_page_confirm_deactivate_text:
      'Please confirm if you want to deactivate {appName} application.',
    ...documentationI18n[LOCALES.ENG],
    ...descriptionI18n[LOCALES.ENG],
    ...technicalDetailsI18n[LOCALES.ENG],
    ...activateDeactivateCompletionI18n[LOCALES.ENG],
    ...confirmModalI18n[LOCALES.ENG],
    ...transactionLogI18n[LOCALES.ENG],
    ...appStatusI18n[LOCALES.ENG],
  },
};
